<template>
  <div class="border p-1 rounded">
    <m-product-offer1 :offer-status="offerStatus" :offer-type="offerType" class="position-absolute" :product="product"/>
    <m-card310 :alt="product.name" :image="product.thumbnail"
               :image-link="{ name: 'Product', params: { name: product.raw_link } }">

      <m-a :href="{ name: 'Product', params: { name: product.raw_link } }">
        <h6 class="product-card-310-text">{{ contentSlicer(product.name, 50) }}</h6>
      </m-a>

      <div class="" v-if="showKeywords">
        <span class="badge product-card-310-keyword m-1" v-for="item in product.keywords">{{ item.keyword }}</span>
      </div>

      <m-product-price100 class="text-center product-card-310-price-manager" :product="product"/>

      <m-product-card-quantity-manager1 class="text-center product-card-310-quantity-manager"
                                        :product="product"/>

    </m-card310>
  </div>

</template>

<script>
import mCard310 from "../../Cards/Card310";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mA from '../../Tags/A'
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "ProductCard310",
  components: {mCard310, mProductCardQuantityManager1, mA, mProductPrice100, mProductOffer1},
  props: {
    product: {},
    productCardLink: {
      default: '_self',
    },
    showKeywords: {
      type: Boolean,
      default: false
    },
    OfferProps
  },
  methods: {
    ...shoppingCartFunctions,
  }
}
</script>

<style scoped>

</style>